export const FETCH_HERE_LOCATION = 'FETCH_HERE_LOCATION';
export const REQUEST_HERE_LOCATION = 'REQUEST_HERE_LOCATION';
export const RECEIVE_HERE_LOCATION = 'RECEIVE_HERE_LOCATION';
export const RESET_HERE_LOCATION = 'RESET_HERE_LOCATION';
